import api from "./api";
import { APIS } from "../endpoints";

export const getAllSectionsData = async () => {

    const result = await api.get(`${APIS.BASE_URL}${APIS.sections}`)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};